export default __webpack_public_path__ + "static/media/beach-meric-dagli.376aa595.jpeg";